(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-product-guide"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('app-product-guide'))customElements.define('app-product-guide',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;
 const select=this.querySelector('[data-brush-select]');if(select){const panels=[...this.querySelectorAll('[data-brush-panel]')];const current=panels.find(p=>p.dataset.handle===this.dataset.current)||panels[0];if(current)select.value=current.dataset.brushPanel;const change=()=>panels.forEach(p=>p.hidden=p.dataset.brushPanel!==select.value);change();select.addEventListener('change',change);}
 const ratio=this.querySelector('[data-ratio]');if(ratio){const volume=this.querySelector('[data-volume]');const calc=()=>{const r=Number(ratio.value),v=Number(volume.value);const valid=ratio.value!==''&&Number.isInteger(r)&&r>=1&&r<=1000;ratio.setAttribute('aria-invalid',String(!valid));this.querySelector('[data-product-ml]').textContent=valid?(v/(r+1)).toFixed(1)+' ml':'Check ratio';this.querySelector('[data-water-ml]').textContent=valid?(v-v/(r+1)).toFixed(1)+' ml':'Check ratio';this.querySelector('[data-calc-note]').textContent=valid?v.toLocaleString()+' ml total at 1:'+r+'.':'Enter a whole number between 1 and 1,000.';};ratio.addEventListener('input',calc);volume.addEventListener('change',calc);calc();}
 this.querySelectorAll('details').forEach(details=>{const summary=details.querySelector('summary');let animation;summary.addEventListener('click',e=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;e.preventDefault();const wasOpen=details.open;const start=details.getBoundingClientRect().height;if(animation)animation.cancel();if(!wasOpen)details.open=true;const end=wasOpen?summary.getBoundingClientRect().height:details.scrollHeight;animation=details.animate([{height:start+'px'},{height:end+'px'}],{duration:230,easing:'cubic-bezier(.2,.65,.3,1)'});animation.onfinish=()=>{details.open=!wasOpen;animation=null;};});});
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-filter')) {
    customElements.define('brand-filter', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-brand-letter]').forEach((button) => button.addEventListener('click', () => {
          const letter = button.dataset.brandLetter;
          this.querySelectorAll('[data-brand-letter]').forEach((item) => item.classList.toggle('is-active', item === button));
          this.querySelectorAll('[data-brand-card]').forEach((card) => { card.hidden = letter !== 'all' && card.dataset.letter !== letter; });
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!customElements.get('collection-loader')) {
    customElements.define('collection-loader', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-load-more]');
        if (!this.button) return;
        this.button.addEventListener('click', (event) => { event.preventDefault(); this.load(); });
        if (this.dataset.loadingMode === 'infinite' && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.load();
          }, { rootMargin: '320px' });
          const sentinel = this.querySelector('[data-load-sentinel]');
          if (sentinel) this.observer.observe(sentinel);
        }
      }

      async load() {
        if (this.loading || !this.button?.href) return;
        this.loading = true;
        this.classList.add('is-loading');
        try {
          const response = await fetch(this.button.href);
          if (!response.ok) throw new Error('Unable to load more products');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = documentFragment.querySelector('.collection-results__grid');
          const nextButton = documentFragment.querySelector('[data-load-more]');
          const grid = this.querySelector('.collection-results__grid');
          if (grid && nextGrid) [...nextGrid.children].forEach((card) => grid.append(card));
          if (nextButton) {
            this.button.href = nextButton.href;
          } else {
            this.querySelector('[data-collection-loader]')?.remove();
            this.observer?.disconnect();
          }
        } catch {
          window.location.assign(this.button.href);
        } finally {
          this.loading = false;
          this.classList.remove('is-loading');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    customElements.define('faq-accordion', class extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-faq-item]')];
        this.items.forEach((item) => {
          const button = item.querySelector('.market-faq__trigger');
          button?.addEventListener('click', () => this.toggleItem(item));
        });
      }

      toggleItem(item) {
        const willOpen = !item.classList.contains('is-open');
        this.items.forEach((other) => {
          const otherButton = other.querySelector('.market-faq__trigger');
          const open = other === item && willOpen;
          other.classList.toggle('is-open', open);
          otherButton?.setAttribute('aria-expanded', String(open));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-detailing-content"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ix-qd-disclosures')) {
  customElements.define('ix-qd-disclosures', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.states = new Map();
      this.querySelectorAll('.ix-qd-question').forEach((details) => {
        const summary = details.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', (event) => {
          if (!details.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          event.preventDefault();
          const prior = this.states.get(details);
          const expanded = !(prior ? prior.expanded : details.open);
          const start = details.getBoundingClientRect().height;
          if (prior?.animation) {
            prior.animation.onfinish = null;
            prior.animation.cancel();
          }
          details.style.height = '';
          details.style.overflow = 'hidden';
          details.open = true;
          details.toggleAttribute('data-closing', !expanded);
          const style = getComputedStyle(details);
          const end = expanded ? details.getBoundingClientRect().height :
            summary.getBoundingClientRect().height + parseFloat(style.borderTopWidth || 0) + parseFloat(style.borderBottomWidth || 0);
          const animation = details.animate(
            [{ height: start + 'px' }, { height: end + 'px' }],
            { duration: 240, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
          );
          const state = { expanded, animation };
          this.states.set(details, state);
          animation.onfinish = () => {
            if (this.states.get(details) !== state) return;
            details.open = expanded;
            details.style.height = '';
            details.style.overflow = '';
            details.removeAttribute('data-closing');
            this.states.delete(details);
          };
        }, { signal: this.controller.signal });
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.states?.forEach((state, details) => {
        state.animation.onfinish = null;
        state.animation.cancel();
        details.open = state.expanded;
        details.style.height = '';
        details.style.overflow = '';
        details.removeAttribute('data-closing');
      });
      this.states?.clear();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-detailing-dilution"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ix-bucket-dilution')) {
  customElements.define('ix-bucket-dilution', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const range = this.querySelector('input[type="range"]');
      const output = this.querySelector('output');
      const water = this.querySelector('[data-water]');
      if (!range || !output || !water) return;
      const update = value => {
        const litres = Math.min(20, Math.max(1, Math.round(Number(value) || 10)));
        range.value = String(litres);
        range.setAttribute('aria-valuetext', litres + ' L');
        water.textContent = litres + ' L';
        output.textContent = (litres * 3) + '-' + (litres * 4) + ' ml';
        this.querySelectorAll('[data-litres]').forEach(button => {
          button.setAttribute('aria-pressed', String(Number(button.dataset.litres) === litres));
        });
      };
      range.addEventListener('input', () => update(range.value), options);
      this.querySelectorAll('[data-litres]').forEach(button => {
        button.addEventListener('click', () => update(button.dataset.litres), options);
      });
      update(range.value);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-ez-kit-contents"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ix-ez-kit')) {
    customElements.define('ix-ez-kit', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.items = [...this.querySelectorAll('[data-kit-item]')];
        this.pins = [...this.querySelectorAll('[data-kit-pin]')];
        this.pins.forEach(pin => pin.addEventListener('click', () => {
          this.items.forEach(item => { item.open = item.dataset.kitItem === pin.dataset.kitPin; });
          this.syncPins();
        }));
        this.items.forEach(item => item.addEventListener('toggle', () => this.syncPins()));
        this.classList.add('is-ready');
        this.syncPins();
      }
      syncPins() {
        this.pins.forEach(pin => pin.setAttribute('aria-pressed', String(this.items.some(item => item.open && item.dataset.kitItem === pin.dataset.kitPin))));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-home-finder"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=(root=document)=>root.querySelectorAll('.ix-finder').forEach(el=>{if(el.dataset.ready)return;el.dataset.ready='true';const areas=[...el.querySelectorAll('[data-area]')],goals=[...el.querySelectorAll('[data-goal]')],results=[...el.querySelectorAll('[data-result]')];const choose=goal=>{goals.forEach(g=>g.setAttribute('aria-pressed',String(g===goal)));results.forEach(r=>r.hidden=r.dataset.result!==goal.dataset.goal);el.querySelector('[data-finder-status]').textContent=el.querySelector('[data-result]:not([hidden]) h3').textContent;};areas.forEach(area=>area.addEventListener('click',()=>{areas.forEach(a=>a.setAttribute('aria-pressed',String(a===area)));goals.forEach(g=>g.hidden=g.dataset.goalArea!==area.dataset.area);choose(goals.find(g=>!g.hidden));}));goals.forEach(goal=>goal.addEventListener('click',()=>choose(goal)));});init();document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-home-help"] && !Shopify.designMode) return;
  try {
    
(()=>{const bind=(root=document)=>root.querySelectorAll('.ix-help__question').forEach(item=>{if(item.dataset.ready)return;item.dataset.ready='true';let animation;let intended=item.open;const summary=item.querySelector('summary');summary.addEventListener('click',event=>{if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;event.preventDefault();const start=item.getBoundingClientRect().height;intended=!intended;if(animation)animation.cancel();item.open=true;const end=intended?summary.getBoundingClientRect().height+item.querySelector('.ix-help__answer').getBoundingClientRect().height+1:summary.getBoundingClientRect().height+1;animation=item.animate({height:[start+'px',end+'px']},{duration:260,easing:'cubic-bezier(.25,.8,.25,1)'});animation.onfinish=()=>{item.open=intended;animation=null;};});});bind();document.addEventListener('shopify:section:load',event=>bind(event.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-home-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=(root=document)=>root.querySelectorAll('.ix-slideshow').forEach(el=>{if(el.dataset.ready)return;el.dataset.ready='true';const slides=[...el.querySelectorAll('.ix-slide')];const controls=[...el.querySelectorAll('[data-slide-index]')];let current=0;const show=i=>{current=(i+slides.length)%slides.length;slides.forEach((slide,n)=>{slide.hidden=n!==current;});controls.forEach((button,n)=>{if(n===current)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});el.querySelector('[data-slide-status]').textContent=(current+1)+' / '+slides.length+' - '+slides[current].dataset.slideTitle;};controls.forEach((button,i)=>button.addEventListener('click',()=>show(i)));el.querySelector('[data-slide-next]').addEventListener('click',()=>show(current+1));el.querySelector('[data-slide-prev]').addEventListener('click',()=>show(current-1));el.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();show(current+1);}if(e.key==='ArrowLeft'){e.preventDefault();show(current-1);}});let start;el.addEventListener('pointerdown',e=>{if(e.pointerType==='touch')start={x:e.clientX,y:e.clientY};});el.addEventListener('pointerup',e=>{if(!start)return;const dx=e.clientX-start.x,dy=e.clientY-start.y;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5)show(current+(dx<0?1:-1));start=null;});el.addEventListener('pointercancel',()=>start=null);el.addEventListener('shopify:block:select',e=>{const index=slides.indexOf(e.target.closest('.ix-slide'));if(index>=0)show(index);});});init();document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-home-kit"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=(root=document)=>root.querySelectorAll('.ix-kit').forEach(el=>{if(el.dataset.ready)return;el.dataset.ready='true';const tabs=[...el.querySelectorAll('[role="tab"]')];const panels=[...el.querySelectorAll('[role="tabpanel"]')];const activate=index=>{tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===index));t.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});};tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(i));tab.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const n=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;activate(n);tabs[n].focus();});});const formatter=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:el.dataset.currency});el.querySelectorAll('form').forEach(form=>{const rows=[...form.querySelectorAll('.ix-kit__item')],submit=form.querySelector('[data-kit-submit]'),buttonText=form.querySelector('[data-kit-button-text]'),normal=buttonText.textContent,error=form.querySelector('[data-kit-error]');let busy=false;const update=()=>{let total=0,count=0;rows.forEach(row=>{const checked=row.querySelector('[data-include]').checked;const select=row.querySelector('[data-kit-variant]');select.disabled=!checked;row.querySelector('[data-kit-quantity]').disabled=!checked;if(checked){count++;total+=Number(select.selectedOptions[0].dataset.price);}});form.querySelector('[data-kit-total]').textContent=formatter.format(total/100);form.querySelector('[data-kit-count]').textContent=count;submit.disabled=busy||count===0;return count;};form.addEventListener('change',()=>{error.hidden=true;update();});form.addEventListener('submit',async e=>{e.preventDefault();if(busy||!update())return;const items=rows.filter(r=>r.querySelector('[data-include]').checked).map(r=>({id:Number(r.querySelector('[data-kit-variant]').value),quantity:1}));busy=true;submit.disabled=true;buttonText.textContent=el.dataset.adding;error.hidden=true;try{const response=await fetch(el.dataset.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:el.dataset.error);window.location.assign(el.dataset.cartUrl);}catch(err){error.textContent=err.message||el.dataset.error;error.hidden=false;busy=false;buttonText.textContent=normal;update();}});update();});});init();document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-home-routine"] && !Shopify.designMode) return;
  try {
    
(()=>{const setup=(root=document)=>{root.querySelectorAll('.ix-routine').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const tabs=[...section.querySelectorAll('[role="tab"]')];const activate=(tab,focus=false)=>{tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;document.getElementById(item.getAttribute('aria-controls')).hidden=!selected;});if(focus)tab.focus();};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();activate(tabs[next],true);}});});section.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[role="tabpanel"]');if(panel)activate(tabs.find(t=>t.getAttribute('aria-controls')===panel.id));});});};setup();document.addEventListener('shopify:section:load',event=>setup(event.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-home-shop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ix-home-shop'))customElements.define('ix-home-shop',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const tabs=[...this.querySelectorAll('[role="tab"]')];const activate=(tab,focus)=>{tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;const panel=this.querySelector('#'+item.getAttribute('aria-controls'));if(panel)panel.hidden=!selected;});if(focus)tab.focus();};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab,false));tab.addEventListener('keydown',event=>{let target;if(event.key==='ArrowRight')target=(index+1)%tabs.length;if(event.key==='ArrowLeft')target=(index+tabs.length-1)%tabs.length;if(event.key==='Home')target=0;if(event.key==='End')target=tabs.length-1;if(target!==undefined){event.preventDefault();activate(tabs[target],true);}});});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-igl-comparison"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('igl-choice'))customElements.define('igl-choice',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const tabs=[...this.querySelectorAll('[role=tab]')],panels=[...this.querySelectorAll('[role=tabpanel]')];
const select=(t,focus=false)=>{tabs.forEach(b=>{b.setAttribute('aria-selected',String(b===t));b.tabIndex=b===t?0:-1});panels.forEach(p=>p.hidden=p.id!==t.getAttribute('aria-controls'));if(focus)t.focus()};if(tabs.length)select(tabs[0]);
tabs.forEach((t,i)=>{t.addEventListener('click',()=>select(t));t.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight'||e.key==='ArrowDown')n=(i+1)%tabs.length;if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=(i-1+tabs.length)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();select(tabs[n],true)}})});
this.querySelectorAll('details').forEach(d=>{const s=d.querySelector('summary');let anim;s.addEventListener('click',e=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;e.preventDefault();if(anim)anim.cancel();const start=d.getBoundingClientRect().height,closing=d.open;if(!closing)d.open=true;const end=closing?s.getBoundingClientRect().height:d.getBoundingClientRect().height;anim=d.animate({height:[start+'px',end+'px']},{duration:240,easing:'cubic-bezier(.2,.7,.2,1)'});anim.onfinish=()=>{d.open=!closing;anim=null}})});
}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-igl-workshop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('igl-dilution'))customElements.define('igl-dilution',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const input=this.querySelector('input'),output=this.querySelector('output'),ratio=Number(this.dataset.ratio);input.addEventListener('input',()=>{const litres=Number(input.value);output.textContent=litres>=1&&litres<=30?(Math.round(litres*10000/ratio)/10)+' ml':'-'})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-leather-guide"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ix-leather-guide')){
    customElements.define('ix-leather-guide',class extends HTMLElement{
      connectedCallback(){
        if(this.dataset.ready)return;
        const bar=this.querySelector('[data-tabs]'),tabs=[...this.querySelectorAll('[data-tab]')],panels=[...this.querySelectorAll('[data-panel]')];
        if(!bar||!tabs.length||tabs.length!==panels.length)return;
        bar.hidden=false;bar.setAttribute('role','tablist');
        const select=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});if(focus)tabs[index].focus();};
        tabs.forEach((tab,index)=>{tab.setAttribute('role','tab');panels[index].setAttribute('role','tabpanel');panels[index].tabIndex=0;tab.addEventListener('click',()=>select(index));tab.addEventListener('keydown',e=>{let next=index;if(e.key==='ArrowRight')next=(index+1)%tabs.length;else if(e.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();select(next,true);});});
        select(Math.min(Number(this.dataset.active)||0,tabs.length-1));this.dataset.ready='true';
        this.addEventListener('shopify:block:select',e=>{const index=panels.findIndex(panel=>panel===e.target||panel.contains(e.target));if(index>=0)select(index);});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-product-comparison"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=(root=document)=>root.querySelectorAll('[data-ix-choice]').forEach(el=>{if(el.dataset.ready)return;el.dataset.ready='true';const tabs=[...el.querySelectorAll('[role=tab]')];const activate=i=>tabs.forEach((tab,n)=>{tab.setAttribute('aria-selected',String(n===i));tab.tabIndex=n===i?0:-1;el.querySelector('#'+tab.getAttribute('aria-controls')).hidden=n!==i;});tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(i));tab.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;activate(next);tabs[next].focus();});});});init();document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-qd-compare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ix-qd-compare')) {
  customElements.define('ix-qd-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.input = this.querySelector('input[type="range"]');
      this.stage = this.querySelector('[data-stage]');
      if (!this.input || !this.stage) return;
      this.update = value => {
        const position = Math.max(0, Math.min(100, Math.round(Number(value))));
        this.input.value = String(position);
        this.style.setProperty('--reveal', position + '%');
        this.input.setAttribute('aria-valuetext', position + '% before, ' + (100 - position) + '% after');
        this.querySelector('[data-before-label]').hidden = position < 12;
        this.querySelector('[data-after-label]').hidden = position > 88;
        this.querySelectorAll('[data-position]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.position) === position)));
      };
      const move = event => {
        const bounds = this.stage.getBoundingClientRect();
        if (bounds.width) this.update((event.clientX - bounds.left) / bounds.width * 100);
      };
      this.input.addEventListener('input', () => this.update(this.input.value), options);
      this.querySelectorAll('[data-position]').forEach(button => button.addEventListener('click', () => this.update(button.dataset.position), options));
      this.stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        this.pointerId = event.pointerId;
        this.stage.setPointerCapture(event.pointerId);
        move(event);
      }, options);
      this.stage.addEventListener('pointermove', event => {
        if (this.pointerId === event.pointerId) move(event);
      }, options);
      const release = event => {
        if (this.pointerId !== event.pointerId) return;
        this.pointerId = null;
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
      };
      this.stage.addEventListener('pointerup', release, options);
      this.stage.addEventListener('pointercancel', release, options);
      this.stage.addEventListener('lostpointercapture', () => { this.pointerId = null; }, options);
      this.update(this.input.value);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.pointerId = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ix-qd-content"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ix-qd-disclosures')) {
  customElements.define('ix-qd-disclosures', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.states = new Map();
      this.querySelectorAll('.ix-qd-question').forEach((details) => {
        const summary = details.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', (event) => {
          if (!details.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          event.preventDefault();
          const prior = this.states.get(details);
          const expanded = !(prior ? prior.expanded : details.open);
          const start = details.getBoundingClientRect().height;
          if (prior?.animation) {
            prior.animation.onfinish = null;
            prior.animation.cancel();
          }
          details.style.height = '';
          details.style.overflow = 'hidden';
          details.open = true;
          details.toggleAttribute('data-closing', !expanded);
          const style = getComputedStyle(details);
          const end = expanded ? details.getBoundingClientRect().height :
            summary.getBoundingClientRect().height + parseFloat(style.borderTopWidth || 0) + parseFloat(style.borderBottomWidth || 0);
          const animation = details.animate(
            [{ height: start + 'px' }, { height: end + 'px' }],
            { duration: 240, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
          );
          const state = { expanded, animation };
          this.states.set(details, state);
          animation.onfinish = () => {
            if (this.states.get(details) !== state) return;
            details.open = expanded;
            details.style.height = '';
            details.style.overflow = '';
            details.removeAttribute('data-closing');
            this.states.delete(details);
          };
        }, { signal: this.controller.signal });
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.states?.forEach((state, details) => {
        state.animation.onfinish = null;
        state.animation.cancel();
        details.open = state.expanded;
        details.style.height = '';
        details.style.overflow = '';
        details.removeAttribute('data-closing');
      });
      this.states?.clear();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('catalog-tabs')) {
    customElements.define('catalog-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
        });
      }
      activate(tab) {
        this.tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          document.getElementById(item.getAttribute('aria-controls')).hidden = !active;
        });
      }
      onKeydown(event, tab) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = this.tabs.indexOf(tab);
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1);
        next = (next + this.tabs.length) % this.tabs.length;
        this.tabs[next].focus();
        this.activate(this.tabs[next]);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
